import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useAppDispatch } from '../hooks';
import Ajax from '../util/ajax';
import * as v from 'valibot';
import { dateStringSchema } from '../util/valibot';
export const sessionSchema = v.object({
    created: dateStringSchema,
    username: v.string(),
    sid: v.string(),
    remoteHosts: v.array(v.string()),
    entitySubscriptions: v.optional(v.array(v.number()), [])
});
export const ConfigSessions = () => {
    const dispatch = useAppDispatch();
    const [sessions, setSessions] = useState([]);
    useEffect(() => {
        const ajax = new Ajax(dispatch);
        const url = '/backend/sessions';
        ajax.get(url, undefined, data => {
            const res = v.safeParse(v.array(sessionSchema), data);
            if (res.success) {
                const sess = res.output;
                setSessions(sess);
            }
            else {
                console.error(v.summarize(res.issues));
            }
        });
    }, []);
    const rows = [];
    for (const s of sessions) {
        const ts = new Date(s.created);
        const hosts = [];
        for (const h of s.remoteHosts) {
            hosts.push(_jsx("div", { children: h }));
        }
        const entitySubscriptions = s.entitySubscriptions.length == 0 ? '' : '[' + s.entitySubscriptions.toString() + ']';
        rows.push(_jsxs("tr", { children: [_jsx("td", { style: { verticalAlign: 'top' }, children: s.username }), _jsx("td", { style: { verticalAlign: 'top' }, children: ts.toLocaleString() }), _jsx("td", { style: { verticalAlign: 'top' }, children: hosts }), _jsx("td", { style: { verticalAlign: 'top' }, children: entitySubscriptions })] }, "s.sid"));
    }
    return (_jsxs("div", { className: "page-container", children: [_jsx("h2", { children: "Sessions" }), _jsxs("table", { style: { textAlign: 'left', borderSpacing: '10px' }, children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Username" }), _jsx("th", { children: "Created" }), _jsx("th", { children: "Remote hosts" }), _jsx("th", { children: "Entity Subscriptions" })] }) }), _jsx("tbody", { children: rows })] })] }));
};
